<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Date of Delivery</h2>
      <v-card class="mt-4">
      <PSUDateOfDelivery/>
  </v-card>
  </div>
</template>

<script>
import PSUDateOfDelivery from '../components/Utils/PSUDateOfDelivery.vue'
  export default {
    components: {
      PSUDateOfDelivery
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>